import { accountsPaths } from "../modules/accounts/AccountRoutes";
import { profilePaths } from "../modules/admin/profile/ProfileRoutes";
import { rolePaths } from "../modules/admin/role/RoleRoutes";
import { userPaths } from "../modules/admin/users/UserRoutes";
import { configurationPaths } from "../modules/configuration/configurationRoutes";
import { controlPanelPaths } from "../modules/controlPanel/ControlPanelRoutes";
import { dashboardPaths } from "../modules/dashboard/DashboardRoutes";
import { enquiryPaths } from "../modules/enquiry/EnquiryRoutes";
import { inventoryPaths } from "../modules/inventory/InventoryRoutes";
import { partiesPaths } from "../modules/parties/PartiesRoutes";
import { productReturnPaths } from "../modules/productReturn/ProductReturnRoutes";
import { reminderPaths } from "../modules/reminder/ReminderRoutes";
import { shopManagementPaths } from "../modules/shopManagement/employeeManagement/employeeRoutes";
import { vendorPaths } from "../modules/vendor/vendorRoutes";

/* -----------------------------
📌 ROUTE GROUPS
------------------------------ */
// All route registries are arrays now. Merge them into a single array for menus and lookup
export const sideNavbarRoutes = [
	...dashboardPaths,
	...inventoryPaths,
	...partiesPaths,
	...reminderPaths,
	...enquiryPaths,
	...productReturnPaths,
	...vendorPaths,
	...shopManagementPaths,
	...accountsPaths,
	...configurationPaths
];
export const allAppRoutes = [...sideNavbarRoutes];

export const cpSideNavbarRoutes = [
	...controlPanelPaths,
];

export const adminSideNavbarRoutes = [
	...profilePaths,
	...userPaths,
	...rolePaths
]
